import { render, staticRenderFns } from "./Tablon.vue?vue&type=template&id=1033fbb8&"
import script from "./Tablon.vue?vue&type=script&lang=js&"
export * from "./Tablon.vue?vue&type=script&lang=js&"
import style0 from "./Tablon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports